"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var enquiryFormDataTransformerGQL_1 = require("../service/enquiryFormDataTransformerGQL");
var enquiryFormErrorTransformer_1 = require("../service/enquiryFormErrorTransformer");
var CustomerTypes_1 = require("../../../../common/enum/CustomerTypes");
var constants_1 = require("../../../../../../common/constants/constants");
var useEnquiryFormValidate = function (requiredFields) {
    var intl = react_intl_1.useIntl();
    var _a = react_1.useState(true), hasErrors = _a[0], setHasErrors = _a[1];
    var _b = react_1.useState(null), asyncErrors = _b[0], setAsyncErrors = _b[1];
    var checkEmptyValues = react_1.useCallback(function (data) {
        var formattedData = enquiryFormDataTransformerGQL_1.default.from(data);
        var requiredFormattedData = Object.keys(formattedData).reduce(function (acc, key) {
            if (requiredFields.includes(key)) {
                acc = __spreadArrays(acc, [formattedData[key]]);
            }
            return acc;
        }, []);
        var hasEmpty = requiredFormattedData.some(function (val) {
            if (typeof val === 'string') {
                return !val.trim();
            }
            return !val;
        }) || requiredFormattedData.length !== requiredFields.length;
        if (hasEmpty) {
            setHasErrors(hasEmpty);
        }
        return hasEmpty;
    }, [requiredFields]);
    var handleValidationErrors = react_1.useCallback(function (data) {
        var _a;
        var hasValidationErrors = ((_a = data.errors) === null || _a === void 0 ? void 0 : _a.length) > 0;
        setHasErrors(hasValidationErrors || checkEmptyValues(data.formData));
    }, [hasErrors, asyncErrors, requiredFields]);
    var handleAsyncValidationErrors = react_1.useCallback(function (_a) {
        var errors = _a.errors;
        var err = enquiryFormErrorTransformer_1.default.from(errors, intl);
        setAsyncErrors(err);
    }, [asyncErrors]);
    var resetAsyncErrors = react_1.useCallback(function () {
        setAsyncErrors(null);
    }, []);
    var customValidation = react_1.useCallback(function (data, error) {
        var _a, _b, _c;
        if ((_a = data) === null || _a === void 0 ? void 0 : _a.tradeIn) {
            var _d = data.tradeIn, tradeInCheckbox = _d.tradeInCheckbox, make = _d.make, model = _d.model, variant = _d.variant, year = _d.year, mileage = _d.mileage, colour = _d.colour;
            if (tradeInCheckbox && (!make || !model || !variant || !year || !mileage || !colour)) {
                setHasErrors(true);
            }
        }
        if ((_b = data) === null || _b === void 0 ? void 0 : _b.customerTypeSwitch) {
            var _e = (_c = data) === null || _c === void 0 ? void 0 : _c.customerTypeSwitch, companyName = _e.companyName, customerType = _e.customerType;
            if (customerType === CustomerTypes_1.CustomerTypes.COMPANY && !companyName) {
                setHasErrors(true);
            }
        }
        if (data.termsAndConditionsWithConsent && data.termsAndConditionsWithConsent === constants_1.constants.NO) {
            setHasErrors(true);
        }
        return error;
    }, []);
    return {
        hasErrors: hasErrors,
        asyncErrors: asyncErrors,
        handleValidationErrors: handleValidationErrors,
        handleAsyncValidationErrors: handleAsyncValidationErrors,
        resetAsyncErrors: resetAsyncErrors,
        checkEmptyValues: checkEmptyValues,
        customValidation: customValidation,
        setHasErrors: setHasErrors,
    };
};
exports.default = useEnquiryFormValidate;
